export const stateOptions = [
  {
    stateId: '1',
    State: 'AA',
    mailingState: 'AA',
    stateTitle: 'AA-Armed Forces - Americas ',
  },
  {
    stateId: '2',
    State: 'AE',
    mailingState: 'AE',
    stateTitle: 'AE-Armed Forces - Europe',
  },
  {
    stateId: '3',
    State: 'AK',
    mailingState: 'AK',
    stateTitle: 'AK-ALASKA',
  },
  {
    stateId: '4',
    State: 'AL',
    mailingState: 'AL',
    stateTitle: 'AL-ALABAMA',
  },
  {
    stateId: '5',
    State: 'AP',
    mailingState: 'AP',
    stateTitle: 'AP-Armed Forces - Pacific',
  },
  {
    stateId: '6',
    State: 'AR',
    mailingState: 'AR',
    stateTitle: 'AR-ARKANSAS',
  },
  {
    stateId: '7',
    State: 'AS',
    mailingState: 'AS',
    stateTitle: 'AS-AMERICAN SAMOA',
  },
  {
    stateId: '8',
    State: 'AZ',
    mailingState: 'AZ',
    stateTitle: 'AZ-ARIZONA',
  },
  {
    stateId: '9',
    State: 'BS',
    mailingState: 'BS',
    stateTitle: 'BS-BRITISH AMERICAN',
  },
  {
    stateId: '10',
    State: 'CA',
    mailingState: 'CA',
    stateTitle: 'CA-CALIFORNIA',
  },
  {
    stateId: '11',
    State: 'CO',
    mailingState: 'CO',
    stateTitle: 'CO-COLORADO',
  },
  {
    stateId: '12',
    State: 'CT',
    mailingState: 'CT',
    stateTitle: 'CT-CONNECTICUT',
  },
  {
    stateId: '13',
    State: 'DC',
    mailingState: 'DC',
    stateTitle: 'DC-DIST OF COLUMBIA',
  },
  {
    stateId: '14',
    State: 'DE',
    mailingState: 'DE',
    stateTitle: 'DE-DELAWARE',
  },
  {
    stateId: '15',
    State: 'FL',
    mailingState: 'FL',
    stateTitle: 'FL-FLORIDA ',
  },
  {
    stateId: '16',
    State: 'FM',
    mailingState: 'FM',
    stateTitle: 'FM-FED MICRONESIA',
  },
  {
    stateId: '17',
    State: 'GA',
    mailingState: 'GA',
    stateTitle: 'GA-GEORGIA',
  },
  {
    stateId: '18',
    State: 'GU',
    mailingState: 'GU',
    stateTitle: 'GU-GUAM ',
  },
  {
    stateId: '19',
    State: 'HI',
    mailingState: 'HI',
    stateTitle: 'HI-HAWAII',
  },
  {
    stateId: '20',
    State: 'IA',
    mailingState: 'IA',
    stateTitle: 'IA-IOWA',
  },
  {
    stateId: '21',
    State: 'ID',
    mailingState: 'ID',
    stateTitle: 'ID-IDAHO',
  },
  {
    stateId: '22',
    State: 'IL',
    mailingState: 'IL',
    stateTitle: 'IL-ILLINOIS',
  },
  {
    stateId: '23',
    State: 'IN',
    mailingState: 'IN',
    stateTitle: 'IN-INDIANA',
  },
  {
    stateId: '24',
    State: 'KS',
    mailingState: 'KS',
    stateTitle: 'KS-KANSAS',
  },
  {
    stateId: '25',
    State: 'KY',
    mailingState: 'KY',
    stateTitle: 'KY-KENTUCKY',
  },
  {
    stateId: '26',
    State: 'LA',
    mailingState: 'LA',
    stateTitle: 'LA-LOUISIANA',
  },
  {
    stateId: '27',
    State: 'MA',
    mailingState: 'MA',
    stateTitle: 'MA-MASSACHUSETTS',
  },
  {
    stateId: '28',
    State: 'MD',
    mailingState: 'MD',
    stateTitle: 'MD-MARYLAND',
  },
  {
    stateId: '29',
    State: 'ME',
    mailingState: 'ME',
    stateTitle: 'ME-MAINE',
  },
  {
    stateId: '30',
    State: 'MH',
    mailingState: 'MH',
    stateTitle: 'MH-MARSHALL ISLANDS',
  },
  {
    stateId: '31',
    State: 'MI',
    mailingState: 'MI',
    stateTitle: 'MI-MICHIGAN',
  },
  {
    stateId: '32',
    State: 'MN',
    mailingState: 'MN',
    stateTitle: 'MN-MINNESOTA',
  },
  {
    stateId: '33',
    State: 'MO',
    mailingState: 'MO',
    stateTitle: 'MO-MISSOURI',
  },
  {
    stateId: '34',
    State: 'MP',
    mailingState: 'MP',
    stateTitle: 'MP-N MARIANA ISLES',
  },
  {
    stateId: '35',
    State: 'MS',
    mailingState: 'MS',
    stateTitle: 'MS-MISSISSIPPI',
  },
  {
    stateId: '36',
    State: 'MT',
    mailingState: 'MT',
    stateTitle: 'MT-MONTANA',
  },
  {
    stateId: '37',
    State: 'NC',
    mailingState: 'NC',
    stateTitle: 'NC-NORTH CAROLINA',
  },
  {
    stateId: '38',
    State: 'ND',
    mailingState: 'ND',
    stateTitle: 'ND-NORTH CAROLINA ',
  },
  {
    stateId: '39',
    State: 'NE',
    mailingState: 'NE',
    stateTitle: 'NE-NEBRASKA',
  },
  {
    stateId: '40',
    State: 'NH',
    mailingState: 'NH',
    stateTitle: 'NH-NEW HAMPSHIRE',
  },
  {
    stateId: '41',
    State: 'NJ',
    mailingState: 'NJ',
    stateTitle: 'NJ-NEW JERSEY',
  },
  {
    stateId: '42',
    State: 'NM',
    mailingState: 'NM',
    stateTitle: 'NM-NEW MEXICO',
  },
  {
    stateId: '43',
    State: 'NV',
    mailingState: 'NV',
    stateTitle: 'NV-NEVADA',
  },
  {
    stateId: '44',
    State: 'NY',
    mailingState: 'NY',
    stateTitle: 'NY-NEW YORK',
  },
  {
    stateId: '45',
    State: 'OH',
    mailingState: 'OH',
    stateTitle: 'OH-OHIO',
  },
  {
    stateId: '46',
    State: 'OK',
    mailingState: 'OK',
    stateTitle: 'OK-OKLAHOMA',
  },
  {
    stateId: '47',
    State: 'OR',
    mailingState: 'OR',
    stateTitle: 'OR-OREGON',
  },
  {
    stateId: '48',
    State: 'PA',
    mailingState: 'PA',
    stateTitle: 'PA-PENNSYLVANIA',
  },
  {
    stateId: '49',
    State: 'PR',
    mailingState: 'PR',
    stateTitle: 'PR-PUERTO RICO',
  },
  {
    stateId: '50',
    State: 'RI',
    mailingState: 'RI',
    stateTitle: 'RI-RHODE ISLAND',
  },
  {
    stateId: '51',
    State: 'SC',
    mailingState: 'SC',
    stateTitle: 'SC-SOUTH CAROLINA',
  },
  {
    stateId: '52',
    State: 'SD',
    mailingState: 'SD',
    stateTitle: 'SD-SOUTH DAKOTA',
  },
  {
    stateId: '53',
    State: 'TN',
    mailingState: 'TN',
    stateTitle: 'TN-TENNESSEE',
  },
  {
    stateId: '54',
    State: 'TX',
    mailingState: 'TX',
    stateTitle: 'TX-TEXAS',
  },
  {
    stateId: '55',
    State: 'UT',
    mailingState: 'UT',
    stateTitle: 'UT-UTAH',
  },
  {
    stateId: '56',
    State: 'VA',
    mailingState: 'VA',
    stateTitle: 'VA-VIRGINIA',
  },
  {
    stateId: '57',
    State: 'VI',
    mailingState: 'VI',
    stateTitle: 'VI-VIRGIN ISLANDS',
  },
  {
    stateId: '58',
    State: 'VT',
    mailingState: 'VT',
    stateTitle: 'VT-VERMONT',
  },
  {
    stateId: '59',
    State: 'WA',
    mailingState: 'WA',
    stateTitle: 'WA-WASHINGTON',
  },
  {
    stateId: '60',
    State: 'WI',
    mailingState: 'WI',
    stateTitle: 'WI-WISCONSIN',
  },
  {
    stateId: '61',
    State: 'WV',
    mailingState: 'WV',
    stateTitle: 'WV-WEST VIRGINIA',
  },
  {
    stateId: '62',
    State: 'WY',
    mailingState: 'WY',
    stateTitle: 'WY-WYOMING',
  },
];
